window.Products.Clothing.UnisexJoggers = function() {};
window.Products.Clothing.UnisexJoggers.inherits(window.Products.Clothing.Clothing);